import * as t from "io-ts";
import { Result } from "./Result";

export const Category = t.intersection([
  t.type({
    section: t.union([
      t.literal("what_is_an_iar_and_what_can_it_do"),
      t.literal("advertising_finance"),
      t.literal("treating_customers_fairly"),
      t.literal("howdens__the_basics_of_offering_finance"),
      t.literal("howdens__what_is_an_ar_and_what_can_it_do"),
      t.literal("howdens__senior_management_responsibilities"),
      t.literal("howdens__advertising_finance"),
      t.literal("howdens__fighting_financial_crime"),
      t.literal("howdens__treating_customers_fairly"),
    ]),
    number_of_quizzes: t.number,
  }),
  t.partial({
    number_of_correct_quizzes: t.number,
    result: Result,
  }),
]);

export interface Category {
  section:
    | "what_is_an_iar_and_what_can_it_do"
    | "advertising_finance"
    | "treating_customers_fairly"
    | "howdens__the_basics_of_offering_finance"
    | "howdens__what_is_an_ar_and_what_can_it_do"
    | "howdens__senior_management_responsibilities"
    | "howdens__advertising_finance"
    | "howdens__fighting_financial_crime"
    | "howdens__treating_customers_fairly";
  number_of_quizzes: number;
  number_of_correct_quizzes?: number;
  result?: Result;
}
